//描述：敏感词校验
//作者：BaiZhiming
//时间：2016-11-24
'use strict';
angular.module('sensitiveWordCheckModule', []).factory('sensitiveWordCheckService', [
    'trsHttpService',
    '$q',
    function(trsHttpService, $q) {

        /**
         * [getSensitiveWordOfContent description]获取正文中的敏感词
         * @param  {[type]} content [description]需要校验的文字
         * @return {[obj]}  obj    [description]返回敏感词对象数组
         */
        function getSensitiveWordOfContent(content) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_sensitiveword',
                methodname: 'getSensitiveWordOfConten',
                content: content,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        }
        return {
            
            /**
             * [checkSensWordsForEditCenter 校验敏感词 采编中心用]
             *
             * @param   {[type]}  content     [content 需要校验的文字]
             * @param   {[type]}  metadataId  [metadataId description]
             *
             * @return  {function}            [return description]
             */
            checkSensWordsForEditCenter: function(content, metadataId) {
                var deffer = $q.defer();
                if (angular.isUndefined(metadataId) || metadataId !== 0) {
                    deffer.resolve(content);
                    return deffer.promise;
                }
                getSensitiveWordOfContent(content);
                return deffer.promise;
            },
        };
    },
]);
